export const playButton = 'svg/play.svg'
export const pauseButton = 'svg/pause.svg'
export const resetButton = 'svg/reset.svg'
export const arrowButton = 'svg/arrow.svg'

export const rainAudio = 'audio/rain.mp3'
export const forestAudio = 'audio/forest.mp3'
export const parkAudio = 'audio/park.mp3'
export const streamAudio = 'audio/stream.mp3'
export const wavesAudio = 'audio/waves.mp3'

export const loudVolumeIcon = 'svg/volume-2.svg'
export const quietVolumeIcon = 'svg/volume-1.svg'
export const noVolumeIcon = 'svg/volume-x.svg'

export const rainImg = 'img/rain.jpg'
export const forestImg = 'img/forest.jpg'
export const parkImg = 'img/park.jpg'
export const streamImg = 'img/stream.jpg'
export const wavesImg = 'img/waves.jpg'
